<template>
  <div class="icon-scroller">
    <button
      type="button"
      class="icon-scroller-arrow icon-scroller-arrow--left"
      :class="{ 'is-hidden': !canLeft }"
      :disabled="!canLeft"
      aria-label="Előző"
      @click="page(-1)"
    >
      <i class="fas fa-chevron-left"></i>
    </button>

    <div ref="track" class="icon-scroller-track" @scroll="updateArrows">
      <div
        v-for="(icon, i) in icons"
        :key="i"
        class="icon-scroller-item"
      >
        <div :class="['addition-icon', 'addition-icon--' + icon.class]"></div>
        <span class="blue d-block text-center">{{ icon.label }}</span>
      </div>
    </div>

    <button
      type="button"
      class="icon-scroller-arrow icon-scroller-arrow--right"
      :class="{ 'is-hidden': !canRight }"
      :disabled="!canRight"
      aria-label="Következő"
      @click="page(1)"
    >
      <i class="fas fa-chevron-right"></i>
    </button>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';

  @Component
  export default class IconScroller extends Vue {
    @Prop({ type: Array, default: () => [] }) icons;

    canLeft = false;
    canRight = false;

    mounted() {
      this.$nextTick(this.updateArrows);
      window.addEventListener('resize', this.updateArrows);
    }

    beforeDestroy() {
      window.removeEventListener('resize', this.updateArrows);
    }

    page(dir) {
      const t = this.$refs.track;
      if (!t) return;
      t.scrollBy({ left: dir * t.clientWidth, behavior: 'smooth' });
    }

    updateArrows() {
      const t = this.$refs.track;
      if (!t) return;
      this.canLeft = t.scrollLeft > 1;
      this.canRight = t.scrollLeft + t.clientWidth < t.scrollWidth - 1;
    }
  }
</script>

<style scoped>
  .icon-scroller {
    display: flex;
    align-items: center;
  }

  .icon-scroller-track {
    display: flex;
    flex: 1 1 auto;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .icon-scroller-track::-webkit-scrollbar { display: none; }

  .icon-scroller-item {
    flex: 0 0 33.333%;
    max-width: 33.333%;
    scroll-snap-align: start;
    padding: 0 8px;
    margin-bottom: 0.5rem;
  }

  .icon-scroller-arrow {
    flex: 0 0 24px;
    background: none;
    border: none;
    padding: 0;
    color: #9aa3ab;
    font-size: 1.25rem;
    line-height: 1;
    cursor: pointer;
  }
  .icon-scroller-arrow.is-hidden {
    visibility: hidden;
  }
</style>
